import { calculateScreen, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, onScreenUpdate, updateScreen, } from "common/screen";
export function letterbox(resizer) {
    updateScreen("#video-parent");
    updateScreen("#pixi-canvas");
    resizer.add(() => {
        updateScreen("#video-parent");
        updateScreen("#pixi-canvas");
    });
}
export { onScreenUpdate, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, updateScreen, calculateScreen, };
//# sourceMappingURL=screen.js.map